/* src/app/shared/strava-record/strava-record.component.scss */
.stravaRecord {
  background: #f3f3f3;
  color: black;
  display: flex;
  width: 90vw;
  min-width: 90vw;
  max-width: 90vw;
  padding: 10px;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: medium;
}
.stravaRecord > img {
  margin-right: 10px;
  width: 6vw;
  height: 6vw;
  z-index: 1;
}
/*# sourceMappingURL=strava-record.component.css.map */
